import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../state/hooks';
import {
    closeFilterPanel,
    loadAvailableCarrierBusinessUnits,
    loadAvailableCommodities,
    loadAvailableConsignees,
    loadAvailableEquipmentTypes,
    loadAvailableShippers,
} from '../../state/features/filterSlice';
import { Filters } from '../../interfaces/filters';
import { serializeFilterQueryParams } from '../../utils/navigationHelpers';
import { useFilters } from './useFilters';
import FilterDrawer from './FilterDrawer';

const QueryFilterDrawer = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const filters = useFilters();

    const isFilterPanelOpen = useAppSelector((state) => { return state.filters.filterPanelOpen; });

    useEffect(() => {
        dispatch(loadAvailableCommodities());
        dispatch(loadAvailableConsignees());
        dispatch(loadAvailableShippers());
        dispatch(loadAvailableEquipmentTypes());
        dispatch(loadAvailableCarrierBusinessUnits());
    }, [dispatch]);

    const addOriginDestParams = (urlParams: URLSearchParams): URLSearchParams => {
        const origin = searchParams.get('origin');
        const dest = searchParams.get('dest');

        if (origin) {
            urlParams.append('origin', origin);
        }
        if (dest) {
            urlParams.append('dest', dest);
        }

        return urlParams;
    };

    const resetFilters = (): void => {
        const urlParams = addOriginDestParams(new URLSearchParams());
        setSearchParams(urlParams);
    };

    const applyFilters = (appliedFilters: Filters): void => {
        const urlParams = addOriginDestParams(serializeFilterQueryParams(appliedFilters));
        setSearchParams(urlParams);
    };

    return (
        <FilterDrawer
            initialFilters={filters}
            isOpen={isFilterPanelOpen}
            onClose={(): void => {
                dispatch(closeFilterPanel());
            }}
            resetFilters={resetFilters}
            applyFilters={applyFilters}
        />
    );
};

export default QueryFilterDrawer;
